import React from 'react';
import { observer } from 'mobx-react-lite';

import stringifyPrice from 'utils/stringifyNumber';
import typeOfCurrency from 'utils/typeOfCurrency';
import { useStores } from 'hooks/useStores';
import useWindowSize from 'hooks/useWindowSize';
import FavoritesButton from 'generic/FavoritesButton';
import { PriceWrapper } from './PriceStyles';

const Price = observer(({ isPurchase }) => {
  const {
    advertsStore: { currentAdvert },
    dictionariesStore: { period_types },
  } = useStores();
  const [width] = useWindowSize();

  const isRent = currentAdvert.advert_type === 'rent';
  const namePeriod = period_types?.[currentAdvert?.period_type];

  return (
    <PriceWrapper status={currentAdvert.status}>
      <span>
        <span className="amount">
          {isPurchase && 'до '}
          {stringifyPrice(currentAdvert.price)}
        </span>
        {!isRent && <span className="currency"> {typeOfCurrency[currentAdvert.currency]}</span>}
        {isRent && (
          <span className="currency">
            &nbsp;{typeOfCurrency[currentAdvert.currency]}/
            <span className="name-period">{namePeriod}</span>
          </span>
        )}
      </span>
      {width <= 512 && <FavoritesButton className="on-truck-page" advert={currentAdvert} />}
    </PriceWrapper>
  );
});

export default Price;
